<template>
  <div style="margin-top: 20px;padding-bottom:10px;">
        <el-collapse v-if="task_list.length > 0">
            <template v-for="item in task_list">
                    <el-collapse-item :title="item.task_name" :name="item.id" :key="item.id">
                        <template slot="title">
                            <span style="color:#f56c6c;font-size:15px;">[{{ item.valid_status }}]</span>
                            <span style="color:#409eff;margin-left:10px;">{{ item.task_name }}</span>
                            <span style="color:#e6a23c;font-size:15px;font-weight:normal;margin-left:15px;">[{{ item.effective_date }} ~ {{ item.expiration_date }}]</span>
                        </template>
                    <el-table
                    :data="item.todolist"
                    style="width: 100%">
                        <!-- <el-table-column prop="id" label="序号" min-width="5%"></el-table-column> -->
                        <el-table-column type="index"></el-table-column>
                        <el-table-column prop="type" label="调研类型" min-width="20%"></el-table-column>
                        <el-table-column prop="company" label="公司" min-width="14%"></el-table-column>
                        <el-table-column prop="department" label="部门" min-width="14%"></el-table-column>
                        <el-table-column prop="status" label="完成状态" min-width="12%">
                            <template slot-scope="scope">
                                <div v-if="scope.row.status=='未开始'" class="not_start">未开始</div>
                                <div v-if="scope.row.status=='未提交'" class="in_process">未提交</div>
                                <div v-if="scope.row.status=='已提交'" class="started">已提交</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="operations" label="操作" min-width="16%">
                            <template slot-scope="scope">
                                <el-button
                                v-if="scope.row.status=='未开始'"
                                size="mini"
                                type="primary" 
                                @click="start_evaluating(scope.row, item.id)">开始调研</el-button>
                                <el-button
                                v-if="scope.row.status=='未提交'"
                                size="mini"
                                type="primary" 
                                @click="view_details(scope.row, item.id)">继续调研</el-button>
                                <el-button
                                v-if="scope.row.status=='已提交'"
                                size="mini"
                                type="primary" 
                                @click="view_details(scope.row, item.id)">查看详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    </el-collapse-item>
            </template>
        </el-collapse>
        <!-- 原来的dialog宽度是1350px -->
        <el-dialog 
        title="" 
        :visible.sync="dialogFormVisible" 
        width="1000px" 
        :destroy-on-close="true" 
        :close-on-click-modal="false"
        @opened="start_interval(form.status)"
        @closed="clear_interval"
        @close="handle_close">
            <!-- 这里直接引用scope.row中的属性无效，所以用form引用该row，通过form去引用对应的元素 -->
            <template slot="title">
                <span style="font-weight:bold;font-size:18px;color:#409EFF;">{{ form.company }}</span>
                <span style="font-weight:bold;font-size:18px;">组织健康度调研</span>
                <span style="font-weight:bold;font-size:18px;color:#409EFF;">{{ form.date }}</span>
                <transition name="fade">
                    <span v-if="show" style="font-size:16px;color:#909399;margin-left:10px;">数据已自动保存！</span>
                </transition>
            </template>
            <div style="padding-left:20px;padding-right:20px;text-align:left;font-size:16px;">
                <p style="margin: 0px;">
                    <span style="padding-left:30px;color:#67C23A;">公司的健康成长和良性发展离不开每一位同学的努力和关注，邀请您仔细阅读并回答每个题目，虽然有一些题目看起来似乎与您所在的团队无关，但它们对于公司的组织健康度提升非常重要，请您结合您的客观判断，给出答案。</span>
                </p>
                <p style="margin: 0px;">
                    <span style="font-weight:bold;padding-left:30px;color:#67C23A;">本次调研完全匿名，严格保密，请放心填写。</span>
                </p>
                <!-- 20231224 增加问卷条件说明 -->
                <p style="margin: 0px;">
                    <span style="font-weight:bold;padding-left:30px;color:#E6A23C;">填写说明：</span>                   
                </p>
                <p style="margin: 0px;">
                    <span style="color:#E6A23C;">- 选择题为必选题，举证题为可选题。</span>                   
                </p>
                <p style="margin: 0px;" v-if="form.low_score_num">
                    <span style="color:#E6A23C;">- 选择题中包含3分（对应选项“基本不认可”）及以下结果的最低数量为{{ form.low_score_num }}。</span>                   
                </p>
                <p style="margin-top: 0px;" v-if="form.continuous_num">
                    <span style="color:#E6A23C;">- 选择题中连续选择相同答案的数量为{{ form.continuous_num }}。</span>                   
                </p>
            </div>
            <!-- 这里通过sendData监听子组件的$emit方法，并通过父组件的getData方法获取子组件传递的数据 -->
            <survey-mana 
            ref="survey_mana" 
            @sendData="getQuesResults" 
            :question_info="question_info" 
            :proof_info="proof_info" 
            :error_flag="error_flag"
            :submit_times="submit_times"
            :is_view="form.status=='已提交'">
            </survey-mana>
            <!-- 按钮的显示，增加一个question_info.length的条件，只有当问卷加载成功后才显示，防止一闪的时候显示按钮 -->
            <div style="text-align:center;" v-if="(form.status=='未开始' || form.status=='未提交') && question_info.length > 0">
            <!-- <div style="text-align:center;"> -->
                <el-button @click="dialogCancel">取 消</el-button>
                <el-button type="primary" @click="dialogSubmit">提 交</el-button>
                <!-- <el-button type="primary" @click="dialogSubmit" v-if="form.status=='已完成'">更 新</el-button> -->
            </div>
        </el-dialog>
        <div class="no_task" v-if="task_list.length <= 0">
            <span>暂无待完成的任务。</span>
        </div>
  </div>
</template>

<script>
// import quesmana from "../QuestionManagement/ChengShu_quesmana.vue";
import surveyMana from "../QuestionManagement/JianKang_survey.vue";
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    created() {
        this.login_random_series = this.$route.query.id;
        this.login_task_id = this.$route.query.task;
        this.getToDoList();
    },
    // beforeUpdate() {
    //     this.display_flag = true;
    // },
    components: {
        // quesmana,
        surveyMana,
    },
    data() {
        return {
            task_list: [],
            form: {},
            dialogFormVisible: false,
            dialogFormVisible_survey: false,
            submit_question_info: [],
            submit_survey_info: [],
            submit_proof_info: [],
            qid_list: [],
            result_list: [],
            request_info: {},
            unfinish_num: 0,
            question_info: [],
            survey_info: [],
            proof_info: [],
            check_flag: true,
            error_flag: false,  //标识检查是否有错误，用于标红未答的主观题
            check_flag_survey: true,
            error_flag_survey: false,  //标识检查是否有错误，用于标红未答的主观题
            login_random_series: null,
            login_task_id: null,
            timer: null,
            timer2: null,
            timer_flag: false,      // 定时器状态：false销毁定时器，true打开定时器
            show: false,
            submit_times: 0,        // 问卷提交次数，当次数>0时，表示问卷有问题提交失败，此时重选错误的题目可以触发重新检测
        };
    },
    methods: {
        handle_close() {
            // 仅在存在定时任务且有答题记录的情况下，关闭dialog才会触发提交关闭前的最后记录
            if(this.timer_flag==true){
                this.$refs.survey_mana.submitManaQues_timer();
                this.getToDoList();
            }
        },
        start_interval(status) {
            if(status!='已提交'){
                this.timer_flag = true;     // 只在调研未完成的情况下才开启定时提交任务
            }else{
                this.timer_flag = false;
                return;
            }
            // let i = 0;
            this.timer = setInterval(() => {
                if(this.timer_flag==false) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                this.$refs.survey_mana.submitManaQues_timer();
                // console.log('i: ' + i);
                // i = i + 1;
                //需要定时执行的代码
            },10000)
        },
        clear_interval() {
            this.timer_flag = false;        //关闭对话框时，销毁定时任务
            clearInterval(this.timer);
            this.timer = null;
        },
        start_evaluating(row, task_id) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            this.getManaQues(task_id);
            this.form = row;
            // 增加task_id的获取，提交问卷需要补充task_id
            this.form['task_id'] = task_id;
            this.dialogFormVisible = true;
            this.submit_times = 0;
        },
        start_evaluating_survey(row, task_id) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            this.getManaSurvey(task_id);
            this.form = row;
            // 增加task_id的获取，提交问卷需要补充task_id
            this.form['task_id'] = task_id;
            this.dialogFormVisible_survey = true;
        },
        view_details(row, task_id) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            this.getManaQues(task_id, row);
            // 如果是查询详情，则需要使用被评估人id和评估类型，从后台获取评估结果进行展示
            // this.getResultByUser(row.id, row.type, task_id);
            this.form = row;
            // 查询页增加更新功能后，也需要补充task_id
            this.form['task_id'] = task_id;
            this.dialogFormVisible = true;
            this.submit_times = 0;
        },
        view_details_survey(row, task_id) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            this.getManaSurvey(task_id, row);
            // 如果是查询详情，则需要使用被评估人id和评估类型，从后台获取评估结果进行展示
            // this.getResultByUser_survey(row.id, task_id);   
            this.form = row;
            // 查询页增加更新功能后，也需要补充task_id
            this.form['task_id'] = task_id;
            this.dialogFormVisible_survey = true;
        },
        dialogCancel() {
            this.dialogFormVisible = false;
        },
        dialogCancel_survey() {
            this.dialogFormVisible_survey = false;
        },
        dialogSubmit() {
            // this.timer_flag = false;        //点击按钮提交问卷时，同样销毁定时任务---修改为提交成功才进行销毁
            // clearInterval(this.timer);
            // this.timer = null;
            // 触发子组件的$emit方法向父组件传递数据
            this.$refs.survey_mana.submitManaQues();
            // 答题不完整，check_flag会被设置为false，则终止提交
            // if(this.check_flag == false){
            //     return;
            // }
            // this.dialogFormVisible = false;
            // 提交问卷后，需要刷新当前评估人的评估状态数据，以及更新待处理评估数
            // this.getToDoList();
            // this.updateToDoNum();
        },
        dialogSubmit_survey() {
            // 触发子组件的$emit方法向父组件传递数据
            this.$refs.survey_mana.submitManaSurvey();
            // 答题不完整，check_flag会被设置为false，则终止提交
            if(this.check_flag == false){
                return;
            }
            // this.dialogFormVisible_survey = false;
            // 提交问卷后，需要刷新当前评估人的评估状态数据，以及更新待处理评估数
            // this.getToDoList();
            // this.updateToDoNum();
        },
        checkManaQues() {
            for(var cg in this.submit_question_info){
                for(var sj in this.submit_question_info[cg]['subject']){
                    if(this.submit_question_info[cg]['subject'][sj]['selected_option'] == ''){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag = false;
                        this.error_flag = true;
                        console.log("this.error_flag: " + this.error_flag);
                        return;
                    }
                }
            }
            // 如果检查没问题，重新赋值check_flag为true
            this.check_flag = true;
            this.error_flag = false;
            console.log("this.error_flag: " + this.error_flag);
        },
        checkManaSurvey() {
            for(var i in this.submit_survey_info){
                if(this.submit_survey_info[i]['choice_type']=='多选' && this.submit_survey_info[i]['selected_option']=='其他'){
                    if(!this.submit_survey_info[i]['proof']){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag_survey = false;
                        this.error_flag_survey = true;
                        console.log("this.error_flag_survey: " + this.error_flag_survey);
                        return;
                    }
                }else{
                    if(this.submit_survey_info[i]['selected_option'] == ''){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag_survey = false;
                        this.error_flag_survey = true;
                        console.log("this.error_flag_survey: " + this.error_flag_survey);
                        return;
                    }
                }
            }
            // 如果检查没问题，重新赋值check_flag为true
            this.check_flag_survey = true;
            this.error_flag_survey = false;
        },
        // 父组件获取子组件传递的问卷结果信息
        getQuesResults(data) {
            // 处理问卷结果信息，并提交后台处理
            this.submit_question_info = data[0];
            // 提交问卷前，需要先检查是否有未完成的题目（主要是选择题）---定时任务提交时不做检查
            // if(this.timer_flag==false){
            if(data[2]=='normal'){
                this.checkManaQues();
                if(this.check_flag == false){
                    return;
                }
            }
            // 每次提交记录前，需要重置qid_list和result_list，防止连续提交时数据累加导致结果错误
            this.qid_list = [];
            this.result_list = [];
            let dimension_result = {};  // 增加按照维度统计结果
            // console.log('getData: subject_desc_sub= ' + this.submit_question_info[0]['sub_category'][0]['subject'][0]['subject_desc_sub']);          
            for(var cg in this.submit_question_info){
                dimension_result[this.submit_question_info[cg]['category']] = [];
                for(var sj in this.submit_question_info[cg]['subject']){
                    this.qid_list.push(this.submit_question_info[cg]['subject'][sj]['qid']);
                    this.result_list.push(this.submit_question_info[cg]['subject'][sj]['selected_option']);
                    dimension_result[this.submit_question_info[cg]['category']].push(this.submit_question_info[cg]['subject'][sj]['selected_option'])
                }
            }
            this.submit_proof_info = data[1];
            for(var pf in this.submit_proof_info){
                this.qid_list.push(this.submit_proof_info[pf]['qid']);
                this.result_list.push(this.submit_proof_info[pf]['proof']);
            }
            this.request_info['login_random_series'] = this.login_random_series;
            this.request_info['task_id'] = this.form['task_id'];
            this.request_info['qid_list'] = this.qid_list;
            this.request_info['result_list'] = this.result_list;
            this.request_info['dimension_result'] = dimension_result;
            // if(this.timer_flag==false){
            if(data[2]=='normal'||data[2]=='modify_check'){
                this.request_info['is_user_submit'] = 1;    // 1：标识该内容时用户提交的，非自动提交的
            }else{
                this.request_info['is_user_submit'] = 0;    //定时任务提交时，标识为0
            }
            postdata.postList("submitHealthSurvey", JSON.stringify(this.request_info))
              .then(resp => {
                // if(this.timer_flag==false){     // 定时任务提交时不做结果识别处理
                if(data[2]=='normal'||data[2]=='modify_check'){
                    if(resp.data.code == 200){
                        if(data[2]=='normal') {
                            this.$message({
                                message: resp.data.message,
                                type: "success",
                            })
                            // 提交成功时才进行销毁定时任务
                            this.timer_flag = false;        //点击按钮提交问卷成功时，同样销毁定时任务
                            clearInterval(this.timer);
                            this.timer = null;
                            // 将关闭窗口改放到这里，超出连续值范围时，不会退出窗口重新答题，可以继续修改后重新提交
                            this.dialogFormVisible = false;
                            this.getToDoList();
                        }
                    }else{
                        // 增加优化，除了提示错误信息，还针对性地对不符合要求的选项标红处理
                        if(resp.data.code == -3){
                            this.submit_times = 1;
                            // 连续值选项超限
                            this.$refs.survey_mana.update_error_info(resp.data.continuous_error_list, resp.data.low_score_error_list);
                        }else if(resp.data.code == -5){
                            this.submit_times = 1;
                            // 高得分选项超限
                            this.$refs.survey_mana.update_error_info(resp.data.continuous_error_list, resp.data.low_score_error_list);
                        }
                        if(data[2]=='normal') {
                            this.$message({
                                message: resp.data.message,
                                type: "error",
                                duration: 6000,
                                // showClose: true,
                            })
                        }
                    }
                }else{
                    // 这里改为文字淡入淡出显示 数据已自动保存
                    this.show = true;
                    this.timer2 = setTimeout(() => {
                        this.show = false;
                    }, 3000);
                    this.timer2 = null;
                    clearTimeout(this.timer2);
                    // this.$message({
                    //     message: "数据已自动保存",
                    //     type: "info",
                    //     duration: 1000,
                    //     // showClose: true,
                    // })
                    // this.getToDoList();
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        getSurveyResults(data) {
            // 每次提交记录前，需要重置submit_survey_info，防止连续提交时数据累加导致结果错误
            this.submit_survey_info = [];
            for(var survey in data) {
                var survey_reslut = {};
                survey_reslut['assessee_id'] = this.form['id'];
                survey_reslut['qid'] = data[survey].qid;
                survey_reslut['choice_type'] = data[survey].choice_type;
                survey_reslut['display_num'] = data[survey].display_num;
                survey_reslut['selected_option'] = data[survey].selected_option;
                survey_reslut['proof'] = data[survey].proof;
                survey_reslut['task_id'] = this.form['task_id'];
                this.submit_survey_info.push(survey_reslut);
            }
            this.checkManaSurvey();
            if(this.check_flag_survey == false){
                return;
            }
            
            postdata.postList("submitManaSurvey", JSON.stringify(this.submit_survey_info))
              .then(resp => {
                if(resp.data.code == 200){
                  this.$message({
                    message: resp.data.message,
                    type: "success",
                    })
                  this.dialogFormVisible_survey = false;
                  this.getToDoList();
                }else{
                  this.$message({
                    message: resp.data.message,
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                    })
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        updateToDoNum() {
            // console.log('updateToDoNum-unfinish_num: ' + this.unfinish_num);
            this.$emit('sendToDoNum', this.unfinish_num);
        },
        getToDoList() {
            let params = {
                login_random_series: this.login_random_series,
                login_task_id: this.login_task_id,
            }
            getdata.getListP("getJKToDoList", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.task_list = resp.data.data;
                        this.unfinish_num = resp.data.unfinish_num;
                        // 获取到未完成评测数后，同步给父组件
                        this.updateToDoNum();
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getManaQues(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getHealthSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.question_info = resp.data.choice;
                    this.proof_info = resp.data.proof;
                    // console.log("question_info: " + this.question_info);
                    // console.log("proof_info" + this.proof_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    if(r != 'none_rows'){
                        this.getResultByUser(task_id);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getManaSurvey(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getManaSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.survey_info = resp.data.survey_info;
                    // console.log("survey_info: " + this.survey_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    if(r != 'none_rows'){
                        this.getResultByUser_survey(r.id, task_id);  
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getResultByUser(task_id) {
            let params;
            params = {
                login_random_series: this.login_random_series,
                task_id: task_id,
            } 
            
            getdata.getListP("getHealthSurveyResult", params)
            .then(resp => {
                if(resp.data.code == 200){
                    var result = resp.data.data;
                    // console.log('result: ' + result + ' ' + result[0]);
                    var i = 0; 
                    // 首先是选择题
                    for(var cg in this.question_info){
                        for(var sj in this.question_info[cg]['subject']){
                            this.question_info[cg]['subject'][sj]['selected_option'] = result[i];
                            i = i + 1;
                        }
                    }
                    // console.log("question_info2: " + this.question_info);
                    // 然后是举证题
                    for(var pf in this.proof_info){
                        this.proof_info[pf]['proof'] = result[i];
                        i = i + 1;
                    }
                    // console.log("proof_info2: " + this.proof_info);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },getResultByUser_survey(assessee_id, task_id) {
            let params;
            params = {
                assessee_id: assessee_id,
                task_id: task_id,
            } 
            
            getdata.getListP("getManaSurveyResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    let results = resp.data.data;
                    for(var survey in results) {
                        this.survey_info[survey]['assessee_id'] = results[survey]['assessee_id'];
                        this.survey_info[survey]['qid'] = results[survey]['qid'];
                        this.survey_info[survey]['choice_type'] = results[survey]['choice_type'];
                        this.survey_info[survey]['display_num'] = results[survey]['display_num'];
                        this.survey_info[survey]['selected_option'] = results[survey]['selected_option'];
                        this.survey_info[survey]['proof'] = results[survey]['proof'];
                        this.survey_info[survey]['task_id'] = results[survey]['task_id'];
                    }
                    // console.log("survey_info2: " + this.survey_info);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
    }
};
</script>

<style scoped>
.not_start {
    font-size: 12px;
    background: #f56c6c;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.in_process {
    font-size: 12px;
    background: #E6A23C;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.started {
    font-size: 12px;
    background: #67C23A;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
::v-deep .el-table__header {
    font-size: 16px;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
/* ::v-deep .el-dialog {
    height: 600px;
} */
/* 设置dialog的滚动条 */
::v-deep .el-dialog__body {
    max-height: 600px !important;
    min-height: 100px;
    overflow-y: auto;
}
::v-deep .el-collapse-item__header {
    font-size: 18px;
    font-weight: bold;
    color: #409eff;
    padding-left: 10px;
}
.no_task {
  width: 100%;
  margin: 0 auto;
  color: #909399;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
}
::v-deep .el-dialog__header {
    text-align: left;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 1.5s;
}
</style>